import { useEffect, useState } from 'react';

const LOOKS = [
  { id: '', name: 'Current', swatch: ['#f5f7fb', '#1673bd', '#111b3a'] },
  { id: 'terminal', name: 'Midnight terminal', swatch: ['#070b16', '#38c2f5', '#0e1424'] },
  { id: 'editorial', name: 'Editorial', swatch: ['#f6f1e7', '#1b1a17', '#a4471a'] },
  { id: 'swiss', name: 'Swiss precision', swatch: ['#ffffff', '#0b0b0b', '#1673bd'] },
  { id: 'land', name: 'Land and market', swatch: ['#f2ede3', '#1f3d2b', '#e0b45a'] },
];

const STORAGE_KEY = 'trelledex-look';

const read = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

const write = (id) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // private mode: the choice just isn't remembered
  }
};

// Preview tool for comparing design directions. Shown on the dev server, or anywhere with ?looks in the URL.
export const lookSwitcherEnabled = () =>
  process.env.NODE_ENV === 'development' ||
  (typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('looks'));

// Display faces the looks use; loaded only while the switcher is mounted
const FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400;6..72,500&family=Archivo:wght@400;500;600;700;800&family=DM+Serif+Display&display=swap';

const LookSwitcher = () => {
  const [look, setLook] = useState(read);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (document.querySelector(`link[href="${FONTS_HREF}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTS_HREF;
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (look) root.dataset.look = look;
    else delete root.dataset.look;
    write(look);
    return () => {
      delete root.dataset.look;
    };
  }, [look]);

  if (!open) {
    return (
      <button type="button" className="look-switcher look-switcher-collapsed" onClick={() => setOpen(true)}>
        Looks
      </button>
    );
  }

  return (
    <div className="look-switcher" role="group" aria-label="Preview design directions">
      <div className="look-switcher-title">
        <span>Preview look</span>
        <button type="button" onClick={() => setOpen(false)} aria-label="Minimise look switcher">
          Hide
        </button>
      </div>
      <div className="look-switcher-options">
        {LOOKS.map((option) => (
          <button
            key={option.id || 'current'}
            type="button"
            aria-pressed={look === option.id}
            onClick={() => setLook(option.id)}
          >
            <span className="look-swatch" aria-hidden="true">
              {option.swatch.map((c) => (
                <span key={c} style={{ background: c }} />
              ))}
            </span>
            {option.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LookSwitcher;
